<i18n>
{
    "en": {
        "love": "Made with love at Stageline",
        "hello": "Hello, "
    },
    "fr": {
        "love": "Fait avec amour chez Stageline",
        "hello": "Bonjour, "
    }
}
</i18n>

<template>
    <v-app>
        <v-app-bar
            app
            color="black"
            dark
            clipped-left
            class="d-print-none"
            v-if="!mobileDisplay && showMenuBar"
        >
            <!-- QUESTIONS VIEW, CATEGORIES VIEW, TAGS VIEW -->
            <v-menu offset-y v-if="loggedUser.shopUser !== 0">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" light class="mx-3 gl-btn" >
                        Questions
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item to="/index-question">
                        <v-list-item-title>Index des questions</v-list-item-title>
                    </v-list-item>
                    <v-list-item to="/index-categories" v-if="loggedUser.createTagsCategories">
                        <v-list-item-title>Categories de questions</v-list-item-title>
                    </v-list-item>
                    <v-list-item to="/index-tags" v-if="loggedUser.createTagsCategories">
                        <v-list-item-title>Tags de questions</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <!-- SURVEYS VIEW, SURVEY TYPES VIEW -->
            <v-menu offset-y v-if="loggedUser.shopUser !== 0">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" light class="mx-3 gl-btn">
                        Questionnaires
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item to="/index-survey">
                        <v-list-item-title>Index des questionnaires</v-list-item-title>
                    </v-list-item>
                    <v-list-item to="/index-survey-types" v-if="loggedUser.createSurveys">
                        <v-list-item-title>Types de questionnaires</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <!-- ASSIGNATION VIEW -->
            <v-menu offset-y v-if="loggedUser.shopUser !== 0">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" light class="mx-3 gl-btn">
                        Assignations
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item to="/index-assignations">
                        <v-list-item-title>Index des assignations</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <!-- MAINTENANCE VIEW -->
            <v-menu offset-y v-if="loggedUser.shopUser !== 0">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" light class="mx-3 gl-btn">
                        Maintenance
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item to="/index-maintenance">
                        <v-list-item-title>Tableau de bord maintenance</v-list-item-title>
                    </v-list-item>
                    <v-list-item to="/maintenance-stages">
                        <v-list-item-title>Scènes</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="loggedUser.userMp" to="/index-preventive-nc">
                        <v-list-item-title>Index des préventifs</v-list-item-title>
                    </v-list-item>
                    <v-list-item to="/index-nc-reports">
                        <v-list-item-title>Index des rapports</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <!-- ADMIN VIEW -->
            <v-menu offset-y v-if="loggedUser.admin">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" light class="mx-3 gl-btn">
                        Administration
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item to="/user-management">
                        <v-list-item-title>Gestion des utilisateurs</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <!-- Retour index des rapports pour shop user seulement -->
            <v-btn class="gl-btn" v-if="loggedUser.shopUser === 0 && isOnSectionNcRepport" to="/index-nc-reports">
                <span>
                    <v-icon>arrow_circle_left</v-icon>
                </span>
                <span class="pl-1 gl-fs-16">Retoux index des rapports</span>
            </v-btn>

            <v-spacer></v-spacer>

            <span class="pr-2">
                {{ $t('hello') }}{{ loggedUser.fullName }}
            </span>

            <v-icon class="gl-fs-30" v-if="isOnSectionIndexNcRepport || isOnSectionNcRepport" @click="toggleLegend">info_outline</v-icon>

            <!-- notification btn button New *KB* -->
            <v-icon v-if="isNewUpdate" class="gl-fs-30" color="yellow" @click="showUpdate">notification_important</v-icon>
            <v-icon v-else class="gl-fs-30">notifications</v-icon>

            <!-- logout button -->
            <v-btn class="gl-btn ml-3" @click="logout">Quitter</v-btn>
        </v-app-bar>

        <!-- DEVELOPMENT MODE  -->
        <DevBuilder
            v-if="ENV.DEV_MODE"
            :devMessages="devMessages"
        />

        <!-- ROUTES CONTENT -->
        <v-main class="gl-bg-color-main">
            <v-btn
                absolute
                top
                right
                fab
                x-small
                class="gl-print-hide mt-6"
                @click="toggleLocale"
            >{{ currentLocale }}</v-btn>
            <router-view/>
        </v-main>

        <!-- FOOTER -->
        <v-footer
            app
            color="black"
            class="white--text print-none"
            v-if="!mobileDisplay"
        >
            <span class="gl-fs-18">{{ $t('love') }}</span>
            <v-spacer/>
            <span class="gl-main-title">Gallup</span>
            <v-spacer/>
            <span class="gl-fs-18">&copy; 1987 - {{ currentYear }}</span>
        </v-footer>

        <!-- OVERLAY ERROR -->
        <v-overlay :value="showOverlay" z-index="10000">
            <v-row justify="center" align="center" v-if="!isErrorState">
                <v-col class="loader-container pa-0">
                    <v-img class="image" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAAC4CAYAAADE1Y81AAAh/UlEQVR4Xu3defR91fzH8d9a5imZShNCSCJFJUqSoUwZQkmGyhShSGmg0SxJZqG5FEXm0GAWIaEkoZJ5yPjX+a3HWev9Xfvzvufce+7wmb7f88dr3c/n3rPP3mfv59nDe7/33v93k5vcpOq16uqmN71p9X/5y16rlnoIevUQ9Ooh6LUUIbjZzW5W3fKWt6xufetb1583v/nN60Tm66aRe7p3/n5V1aJDIAG3ve1tq7vc5S7V+uuvXz34wQ+utttuu+rJT35y9ZjHPKZ6yEMeUm2wwQbV2muvXa2++upTFZ64bne721WbbLJJtc0220x1r/mUdLaB73svCpBHqe0eWYsGgQdRqPe73/2q3XbbrXrf+95Xff/736/++Mc/Vv/4xz+qf/7zn9WNN95Y/elPf6quvPLK6pxzzqle97rXVY9+9KNrINQU+Z6jdJvb3KYG62tf+1p1wYUXVA996EPrdOTrFkPSAVDP5mW44x3vOHDNLW5xi2qdddapIfZyDJOX6e53v3sdJt8nayYQRIFK4GqrrTbweykRKsD73ve+1Wtf+9rqBz/4QfWvf/2r+t///jdS//nPf6obbrih+tSnPlU96UlPqu5whzt0pt2bcf/737/6+Mc/Xv33v/+t4Tr55JOr9dZbb+DahZS8u/3tb19ttNFG1Yte9KLqrLPOqj73uc9Vz3zmMweeba211qre8IY31C+Fl+UPf/hDq66++urq2GOPre5xj3sMxJk1NQQy9173ule17777Vp/+9KerF7/4xTXR+bqQqv+xj31s9cUvfrH697//vaKAFYxCjs8m+S1g+OUvf1ntv//+I6EjD7nmmmtWr3nNa6q//vWv9T3ELaPULpPUKrOQ5shbr/AvuOCC6u9//3udrh/96EfV7rvvPgDBuuuuW73jHe+oAcgvSJba9POf/3xda+R4s6aCQFUjko997GN19a1wfvrTn1a77rpra8Yi09sYBR+F6uEzBPFdk/z29a9/vdNDagZ22GGH6sc//vEc4NRA3/nOd6pHPepRAxk+nxKXt3/rrbeuPvShD1W/+93vVqRJPl566aV1E5nTpKZ961vfWr/pZYELG4rv5M+3v/3t6uEPf/hA/FkTQwAA7c4nP/nJOYkR+SWXXFLtuOOOjR0vtcYZZ5wxJ0wU/jCVgPhUgN/85jerTTfddCCOUqrbe97zntW73/3uOmyZaf73Vp1wwgl105LDzoekZ4011qie/exn130T/Z7yhfBcP/zhD6vnPve5nSDI+VP+f9lll9UdbLV1TkepiSDwINp0NUBJZAjN3tKtttpqIAEgOP300wceYlx1hUBzIcN/85vfNGYaaNUQT3/60+e9k+j+CvJlL3tZXeWXUEZ+eK5hNcFb3vKWFRCU+VHWkvGbJnOvvfYa2WSODYEAEnPooYfWFEciMgh/+9vfqs9+9rPVAx7wgDnhFxKCgPWjH/1oHVfZlMTf7qWTCGg983yPWUm+3fWud61e/epX102meMsmcBwIfv/73w8A7V75ua677rrqjW98Y13z5PTktI0FgVHAHnvsUffS40EiMSUEvr/mmmtqWMo3bCEh0O7qYMk0YXJGhcCsCXvOc54zL7VB9AHUNgCI5y4LjAKCYc1BQJDzw3MJq0P45z//uQb7V7/6VXXMMceMHAGNBYEMMgb97ne/O+fNyg/ifwk96aSTqvvc5z5z7lH2CSKMhKvi/vKXv8y5V/mAahaFFb+PgiCGhKeccspAppcKKPQNDBnvdre7DdxrWhkRMYCpGeOZmvIunqtLTZDziBT++eefX73tbW+r3vSmN1WHHXZYDV6TzaHUWBCoLt/85jcPvMVlZnoItYTq1fAn36OEwLVoNbSU4DPPPHNO4QTdv/71r6tPfOIT1Re+8IXqqquuqoHQ7xgGgWHqzjvvPNAXaJP7sVmoOWZZG9zqVreqjVIA8zxNaYnnlQYjBfnx+Mc/fmwI5JNhcBcDUanOEOjpG99LZNuDkDe6DQAKCIyJv/GNb9TEqyrvfOc71+P+8l7k7TeG1rYrWJlz2mmnVddff30NwWabbTYQh4cyFDUiaEprkxSCzDVS0Hbne04itZGa8J3vfGdd2zW9+fGd3zUVb3/726sHPehBAx1qGgUB4OVh2/C8TZ0hYK2SgLZM9SDe0HPPPbcusBw+BAKQnHfeedXmm2++4ntzB69//etX3CtqFm/HRRddVFftrouO6UEHHVR95jOfqZunHIdMAKwhUlt6s6IggGVYld/CcSW8mlOhANb91WpNEGiKVOP6AcOq7kWFQPWoSis7NflBFJY3+5GPfORA+FIsd8961rMGjDwgOPDAA+fcM+574YUXVhtuuOGKa6OnrbCYW3Mc7sUkHQasnPFR9ebv6Le//W39No4aVg2T9LE7qOWAWN6/TIu/AaKpYDga1QwtKgSqayMCJEfiywfy/RVXXFGPf3PYLBE2VXVRE5SdOJ8BQdQE+V4549wbYNrVsvMa/QvNkLSyFPrf9xEf+f1LX/pSDX2Or6sUAkudWjH3nyIucSs0E2cPfOADB+7RpEWFwGyUKlxEUfglCPoBHmYaq1sJQZlpMqsNgiZ5g3fZZZd6jFymN95+tdk+++xTPfWpT60nYnJNIb6f/exn9VxIE6yjBEpNHsseoNoA0InTZylruFHqAsEkcyEjIXAB87CMKd/SUDQDZfs+iWYBgbSaZJFRUbCRTvcxeeTt1GnVcTTLVrbTca0xtqEl+HMco6RNf+ELX1j94he/GACAwAhQBqymTu0wLRoEbrjTTjvVY/gmCLRpxqWTvDWlmiDwqZDKjuEwGRqB0fWRzviM4egBBxxQP7SRhr6JPkD5TP7WQQS2+Y8cxzCJ35D11FNPnRN/KWN5TRW/iHE7n4sGAbJf9apXzXmg8u3iCLLtttsOhBtXs4BAwWoK2CnyW2ioqWAf9rCH1deCVltslFI+l09xskdIzzhwG+buvffeA7aJyC9pMLNnFDBuQdGiQWCYY5xb1gLRzhoScoJQgDncuJoFBEYehxxySJ2+XAhqMubqMq2uN9SMzmEpTcKJJ57YeT6BHcVwNVtDAwBxqImkz3A7h++iRYNAJ4cnT1NTcO2111ZHHHHEQJhJNC0EOmQ6WWEmzgVhHkMBlGHCqug5coZ6a7/yla+sqDlG6U53ulP1kpe8pG5emvJKJ5EtoMmu0VWLBoHMj7mCeLD4NNQy6ZLDTKJpIfAmapbCcaSEwFtoUkbfpgyjDd9yyy3r+5fXk3hN9+rk5biy3IeVz1xJLnxyLxAeddRRYxdQqUWDwMO1jQxk7CjjUFdNC4G3mkeTarypQJme87S22uPe97539YEPfGAgTNR03LmanGNKsaPoi8gnYUvDkE+jEpNHgMthx9GiQODHLbbYYo4TQ9QEHk6nsGt1OUrTQmDOXAa4PheoQjj77LMb59XFG3MWOZx+hHmKYVOx8sjvRx55ZD1czveQT4aLrKGjYBqlJQVBEG7Wjbkzh5tE00AgnVzI3v/+988JH+k1Wnjve9/bmDneYlV+6eYVin4BD6kcLmSWUB7wEM5xk86z2c9pawFaNAiMu8shV9kcXH755dXTnva0gXCTaBoIDOM0W4Z7uSCks6lTGOKE+pSnPGVgWEfebM4m7Ak5XIiV9AUveEEdRw4vbpbBo48+euyCadKiQEDs8MyrHrAEIB4wjC853LiaBgIdM7b6733ve40F8fOf/7x2hc/hyJvM27hpxlHc2nlm5qZn1KdgVeTA4dpcKGoSaTf9ncNOoi4QzMvcgcxn4MhvF+mEffjDH67fphxuXE0DgYdm3eNYmQsyRgbmCnI4UouYLDKFHGHLJs+Qj0UULDmsNl5zWQ6hy/CaUf4Jk9oFshYNAr3nmA0rM0ekXQqoq6aBgPuWKptJNmeMtKohuHflcBSzjmYO4xmjIIU118/Oz7cyhzUi0Rz+5Cc/mZNuYaVbc/nyl7+8sRaZRIsGQWkxLJuCeFi2gianyHE1DQQKyCqepipZQX7rW99qHcWo0t071k9EuIDAyIJV1MRUDstM/MpXvrIGJcLEZ0xJqylyuEm1aBCYO9AmlgCUIHj7rCgatvSsi6aBIIZ5Cq0sSBI+O6WUkgFcwAwFyzc5xvkK0xh/4403nhMOPGYiNRUlOPGpoDSVTcPSSTUKAn00HcNxm+eREKCKB4/2v3zQ+Fsmc9AYNozqomkgUFuxxmUASPjwUczhSAYozA9+8INzwgXoOndWCmWjWKzAMmOY4xUn24ACmbaGLDUKAjWBdQZqLWZsNVXIy9xmpxgJgQtMjzb1niOzdJ5EPq6Xa6lJIZA+/gHHHXfcnLBlgagJLIHPYSN8QFDWBCUEmhMvQhnOy2GZu5VWZbwR5uKLL57ZqCA0DALxqpUByz3OiIVnuOvJRJlyzJ5YNBIC4osfb0pZE4SMp4e9bV00KQQeSnUeq4xy2qaBQJMQruj8BctwMfnU5DzCQMRnoMn/cRqNgiCasMi7UqbG9d2amopOEHDZet7znjdn2VlOgOGZnnATaV00DQQy27qEshAjbdNAQCAwkcTHsgzHSKQzWrrgR7w6itzxZuW6HhoFQVb5OwiA3NRp7ARBrDwy3s7Uh9DfZp/vokkhiCGetfhNaZsWAuEN9TiLlOE8p85o6XEVioknQ9cc3zQaBoFaIGqCptpgaggI1cyfYSPIErHxcp6u7appIGAy1oPPhUGTQlCGNwzeb7/95oTR+Tr88MPnzDkIJ384j9hRZJadQhoFQa4FZg6BniW/OA/YlNkilrjjjz++MaJRWk4QqBl1Rg0Pc7WrMJjZ1RI5rmk1DIJQBiGk78L3o6lsOkNA6H/Pe94zEEFELgP48eUxdRctNwh4XL3rXe9acW18ygNzFZag57im1TAIxMumwVag+SLu9eY+yKjBRFmT+XssCNzgcY97XO1hnDM86FPt6DCNWxUuJwjEyfhUholwrm/qSOY45aWxu75Fk3Q887h+GATRgZVOruxsGCFDQ0618jinJdLTGQJSDXLYzJkVfxur6hmPu4xrviCIFUzzCUF5vfh0oE0v57hCqmQdbWN39wjxcPKpSbW6OA8xh0EQ3tTe9hzfKI0NgcK1fLu0IJaSaQwlbWbaNi02BKWLWRcI3C/XBHH9qObAXIf22T4E8bylFCgjlG36ynCjIDDbaz+CHN8ojQ2B9pCvXvjry7CyZ+pvbdAwR4wmLQUIIkwXCBiovLE5Ts+vSeRnkeMK8WayjxIjVAaALH7RhmeL45KBgLRlDENhPMq1AQOKcfI4/YLlBEGMDphnXVvGCwL7I9qmp+35AwI+mhmAZQNBuHer9iQ6Mi0+GY5MzY6zQHU+IWDSztvmhCaBQBjOpewmfi/D+DSXMsxYBAI15bKGgGRcm70+horZxXuY5gsC4bWvOmJm1rLEq/f8kY98ZKBGa4OAwrs5dkgtIQhHFCuccnqpCYIyzSD46le/uvQh0CRwqGiyIMoIs45PfOITB8K1ab4gCAueN52Fz4qpUPzP9qFAxBUAxHO1QeD57cegQHK8akIbcrdNqGUIcpongUCNt+AQmI3it9e0h5FM1C6CJIdr03xBEOnJ32W5JiCIjq7v2yAwSrLYxXOWNQEpREvO2nwsRkHA6LMsINA54qDZNqkkoeb42zpHWfMNQTmCyb/na7pA4CVQSBxqcrxhKzDzmtNLKw0EAjqMInvahmJWsa1zlDXfEOTvmtR0XRsE4Wnc5puoc2i3kmz1o5UGAjKX0LZNnETZzr7rnPp8QjCN2iBQE1r1ZBSg4CPuqG1YTi1TN8eQ0xwQWNjSlOZlBQHfNUaRpgfxNhifqy1yuCYtNwgizb5X4BmCsPo94QlPGGgSVyoImD+tyS8LLgQCiTKBkcM1aTlCoHPohJKm/Yo9vxk9vn65SSwhyPHRsoLAw9hKXSJyAcgIZtEuhy7QfEIQBVMWUP6uVITxOQwCM4GeL9ZA5rjCXT1vvbtSQcDZ0kRI21ZtIHjEIx4xEK5J8wWBdDDo8IGMufUsTiAW3YqLuowOaNRaRN+xqgpbdhBXOgiMlZsgILuG8D/I4Zo0XxAIrxf+jGc8o34js8y9S6NjaGQkALpCQJrE5z//+Y2rkim2zeMHGX2DlQoCGWC1b05QiM9hng5t03xBEHMHwzqozLvWTeRagEZBEE2C+HPcEZ5rl6Xx4WOxUkFgdGAP4abMl5E8XWw0ncM1aT4hGLYMjUDAfBym4vikURDIQENlELEUNqVBoQKRj6YmJCCwUDZfG9cvGwg8fKz8yYmSkUjvukPHfEPQNpVMbBm2m8mdQgoIePrkcCFvuOZG8xfho1kh97CLqfkLca00EAhollBimzLfw5tJbCu8rOUMgTS4v4mo8lyDsn8hHSbVmJIVZglBGR8tGwi0hRJpLJwTRIwl9uppm07NWs4QUNgM4pSzqAHKGsFCFcvVdaZ1Jm0NmNNLywaC6A940JwgYkUzp97k4tyk+YJA+IWAIJaqWx1tRJCbhFCcU2RXeMDk9NKygCD8DJ08kjMt/jeHb0/kHLZNyx0C4kWs82fHM+GiWchpUmBqBZNs+TdaFhDEXHoci5cf1P8MReNsfL0yQCAzeRzxo7BXQE5LVy15CNQCxtxx+nhUe2WCdI6YUsfZsGllgIBii1u7lLS96aM0CQQL6l5meKNTUx7yXGaav70Fw7xtm7SyQEAsqYxk0i18TtMoLWkI1AKWM5U7fWUI1ArDNopq08oEAek480E0Z9F032GaBgL2ipyWUeoMgQtV7wcffHDd/uQMj/GwBFqUMe5GVisbBNJl+z+TS2rNcsiY05g1LgTSuyAQxNKppu1fIyHgYADRQ87hR2llg4DMHPKn4M5uaBgvSk5j1rgQUAmBQi2V05XVCQJDH5tBsgA2ZTRFLcBqNm4tQEsFAveYFQTEIdVLYQ8j9oOcviZNCgEzvRXhFsbY0U3NzTVeHuV0lRoJgd6u6VZOo2XhlAmQaUYECqvrXEHWUofAEXk5XFd5KazB+PKXv1znU05j1iQQSKdtcozK+H0S/8c999yzDpfTVGokBMy+tl5R1cscVVpkVEgCLMK0O8co6to0LQRtW81H+EkgiGfjPvaKV7xiINw4ii1wva0KubQi5iZiksUn5T0iH8QDinwabdZICAwJLZ5k4gwQItLIJIkyLh7HLpA13xAMm0rOEOTwZgeHbTrRVUYMfDJtpq1pGAbBuGsRS0U+xEqoUSewjoSAWAjt2RcgRGQSz/yJtuxHN65mCUGpSSGIT887aueRcWSRrpfK5Jpd0MvRQqS5CwQZ1qyAwLqQmUBAMWduYwUZI/EisSHFOGsO2wSCgw46aAAC8YhjviEw8bMQEJDOom1yTbCZY4l+QoZghx12mBMOBBa0xEk0bSDEbzOtCUJAMA/+48t+XFdn2jdHx0zaDyjVBAEpRP77wyDQ5lnokgGYBgLyf0DQ5VS0caTDbcGqlc1GXWwJ0dyCgCdSFwgyCOX3IODfOFMIiL3A5JGbv/SlL23cEm0SgcBCFkMdmRACm05SWyGCwEOa0SzDleHN6rXtT0Ag4F6mI9UUHuxt6wqnlTUJagU7obGx6OErZGlugkBzABhwjxLbhG36895HWWNDQArefsd5UcU0CrgMo5ilvdnaTUM/5y20HV4du4Zo083TC1NKeDuKNJ1XEDKWttFUDmuXVM0MtzCbWedws5JCUMtyWGWR1Y7raOed1c1QGqV4Tg4pFsMOk2bUXouWy+U4c/xjQzAfkhDDKCMMw9JSCmnYnslqAx2uprCxHdwwy5l7K4Sm8KRXP6sab5Q8i/g4qOTTVuI3hWomd5jUfD4ZjUY110sGgl6Lpx6CXj0EvXoIevUQ9KIegl49BL2WEQQS2qR8Xa/xNRICF1hFxDpIJj8o/m7anWuWEr+48nkAxNTMEDTNUXzTiiFG+ky5ZzFAyaNhhq4uEt594p6U48pieOuaLyMhECHzJf9CZl3ToLvsskv9t7V3vIrn8430QDZ/Ytu3/DuLRy+HzhxuEnkOGdc18wDAnC0/zKOE+Az45Orl/AFWuxy2qwAgvHMZ4972hPA5TI4jMGfQBcCRENiCzSREnlghExmcKJvO2puFJE4mm1zJs4NkmtlKp657IIySGs/zDvNCKqUGsKtrbPSddeM/b6wuuPCCapttthkI21Xydvvtt69nFfP9h4lDsLWi9m/O98waCYG3zAxdjsS0ZZyT3HXR6biSOBNVcWB3FgjM8MmkHHYSsdXvuOOOte/AKHs7gcCbXp6aXsqMKL+Arvs2NSnWN7pP5HuOp0k22TbxZQ4i3zOrEwQ8Zd24dC0LCBx1M1+TK10hmMTFvUkmqvgN2L+oS+YFBHGEcBYITIPPBwTZkST7E4jbdLSth/M9szpBwHegKeKAYL46hwsNgRk6U7W8ky3nGtXXWUgI3KepDLIibi+qdFkON6pW6wRB2RyUEa1sEGg/rSi2dOzYY48duX4CBDpsHFHL/Ik8mg8IslNqKBx/Q77juuYsplGHj0wMgc/YiGIhISgffD4g2GeffeoOL6eWUbuxZghywSwkBPJCfFzKiJeUzqG8sxgl37dUJwiiT5AfdKEgsIiiKX4PPumytybpE2gOuHc5XNJQa9gQa6lA4DtucLbX5/ntpfVpwRAfRnmY71tqLAgiwpUdAsf90aiTz5cSBJow2+ypzdhWjHSoiwtgD0GhEgKev7ych/kWdoFAD30hILBhJmPSqM5sk5YVBPnh5xMCz6ljxSrZNgReahCwnvYQTKkSAvFpZ7Wvbae6LTUI9t577x6CaRWHfgYEmoQ4y6gpc3sIVgEI3N9w0Z6DDEn5+h6ClRyCeFYTZUy2eSEI9RCsxBCYfIn7W84lgw888MCBKeYegpUYgmgO4nk955lnnjlwslkJQU4b9RDMQEsFAoUpHiuyy0zuIVgFIAh5ZoddHnPMMXPWBwYEbRtV9xDMQIsFgT5Bjs+EjJXKm2+++YrrewhWMQh0EJ2cZmo25ud7CFYxCEgzcdppp61Y799DsApCoFBt/mArOmnrIVjJIchxkSaBo4b0uBYE3Ld6CFYhCDw7rx0dROstRkHA2thDMKWWIgQmlexw6mgfzhs9BKsYBOIj7mcnnnhivQUdCMw05muph2AGWmoQeHZxKlx7D1qGp2MYEOQC6iGYgZYqBDqIvI5sjWdtZl8TrGIQxPPzOtJBdA6C9ZD5WlpoCHr3sobw42ocCAz/dBAZj6xFjPSU1y80BL2jaUP4cTUKghw3C6LML0+GK6/pIZiBljIEkReGjPoI+TdaKAjkAwg4yVrKLoyV4j5DyqgNkB6CQuNCEPmRm4HQQkLg4PLjjjuuHrLaGNtZCZbZk/+32mqr1r0KeggKjQtBAFCq/H3WEEScTekQ13XXXVfXCHTllVfWn1Ym+dum2W3L1HsICo0LQaQhYMgFtFAQlN/7lFelpM1xeU3OstRDUGgSCIZpoSGI2iiuCQj0WZxa27ZtTg9BoeUMgbxQ2GXT5FrSeXX4Vg9BBy11CORBEwS+Y7e44YYb6g5iyLQ3XXPNNfXhHW3nV/cQFFquEMgHhc0t3gJa51j6POyww6rDDz+8/nuvvfZqPT2mh6DQKAia2t1hWigI4oxq8xjDNtVoUw9BoTYIol11BiSnkq4gLDQEZjVz+C7qISjUBoF4HEj5wx/9sLrql1cN5EObFhoCi2Ny+C7qISjUBoFet7OgTz/99LqDlfOhTT0EM9BiQlDGF2sOpMMRc3FCbFOBlJoVBNttt10PwVKBIHrZzLPyoalASs0Kgm233bY+L7IpD6iHYAEgEM8VV1xRL0+3kZXNpnNeNGkWEMhb43uHfLbF2UOwABCoCexkzovIoZNm6+Jc45ymUrOCwPpHZdBW+/QQLAAEURPEFrE2udQk5PRkzRcEGYQegnmAoNyfIOIJCDhtOF/BJtg5PVmzhMAuak0AUA/BAkNgRbJDMY4//vhWj6JQD8EMtNQg2HfffevreOi4zoRNTlOpHoIZaKlCoEngvmUBSk5TqR6CGWipQqBJ2HDDDev9DWMOX7747CGYsZYqBGRzS4tSzSkEAAFDD8EMtZQhiGXp4g8IcgH1EMxASwECn00Q2NjSxteOBAwAcgH1EMxASxkCckKrgyYYl5oKZxY7lfQQLBIEpcVwGAQOynIaWtuCVBCY/eshmEJLHQJNgsOyTj755IG0UQ/BDLTQEDACsQp6ri4QSN+aa65ZHzbF9Synr4dgBlpoCBSo6WK7l3aBgDQJzku2UUVOYw/BDLSQEIhrrbXWqg455JC6V98VAs++6aabVqeeeuqK60M9BDPQQkPg+LuDDz64FYL99t2vMRx4DjrooHr3kh6CGWvJQbDfIAS02mqr1QVg55IeghlruUDg+S37Puuss+r86SGYoZYLBMKuu+669fIvi1N6CGao5QIBaRJ23nnnukmIfOohmIGWEwQMRxtvvHF9vrLr5ZP7OEmth2AKLScIhGdn2H///VccqddDMAMtJwiI4WinnXaqLr300jpcQLD11lsPXNtVPQQ3vWm13nrr1dvHij9nwFKDQJOwySabrJhLWGUgOOGEE+YVgrXXXrs66qij6vhzbbDUIHAPhiOmZ3MJOoZWK/UQTCntLFNuFMhCQhDqCgHFKOGyyy5bcAgWfH8CnzpAqj70W5ljKpZkhBvne02iNdZYoy6Y5QKBQjOXYBk7CCxSWSgI7FTCCdZuJaEu5TARBDKFzLaJ3GpdmeeN9bn77rvXIOR7TaKAYDGagxICG0J2gSCaMPfhl7BQEDilleOrhTEbbLBBfSCHdZPSEkf4tWkqCPwNBOvyrr/++nqj52uvvba+Xocu32sSLTcIyAuwyy67VJdffnl10UUXzTsE0sfr+eKLL65OOeWUWnZfdzqLmU/WzHzfUhNDwN++TFSZYehv2ylrXGUIcuFccsklSw4CBbfllltWZ599dg1B2/6BXeReW2yxRXXeeec1AhAqX86Qzuk555xTO8Tm+5bqBAEKSwhybZCp1BlajhCEP4G2PMczDgTupSY0l3D++efXm0zka7pqHAji70i3eQx7GrNk5vuW6gRBWROUkTYlatYQxOggA1BCsP322w+EG1cBwaGHHjoAgee0WbT9CXK4NjkpzZDtpJNOqrebyb931SQQhEAws5oABDmCNmkmZg2BgnHvDOJ8QBCeRTmecWoCct6A6eUDDjhgphC0vXxNAsG55547PQTOBeY6peNhFe4o6SBqPkZ1RrpKc8Ae7945DeJikWvbvXscyQjAKeirr7667uzq5JLdQm0Q7WSRHK5NhmegspeB/kH+vatAsNlmm1VnnHHGQF6Pkq1tDeE32mijgfuWGgkBD9xdd921Ovroo2vL3RFHHFHryCOPnCO/xe977LFHbTfI95pE7PHeJPcWj/tHXP53Atj6668/EG4SWVpmfyBDLeCFNAN77rlnXRg5zDApwHXWWWeqkRKYvFC77bbbiueOZ29TXGPobpQC7nzfUiMhcIEdtBTq6quvXg9/tHdN8rtPmZnvM6nELzNzXCGQuCaHm0bu16Z8bRdNGi4EBHkaeRz5PEqu61IWIyHotfKrh6BXD0GvHoJePQS9qIegVw3B/wMcRYV0fGKRdwAAAABJRU5ErkJggg==" width="140"></v-img>
                    <div class="loader loader-top"></div>
                    <div class="loader loader-right"></div>
                    <div class="loader loader-bottom"></div>
                    <div class="loader loader-left"></div>
                </v-col>
            </v-row>
            <v-row align="center" v-if="isErrorState">
                <v-col cols="12">
                    <v-icon size="64" color="red">error</v-icon>
                    {{ errorMessage }}
                </v-col>
            </v-row>
            <v-row style="text-align: center" v-if="isLoading && (isErrorState || showLoadingButton)" >
                <v-col cols="12">
                    <v-btn @click="closeError">Fermer</v-btn>
                </v-col>
            </v-row>
        </v-overlay>

        <!-- Legend color of the Chart -->
        <v-card v-if="showLegendDialog" style="position: fixed; top:60px; right:150px;">
            <v-card-title class="pb-1 gl-fs-20 gl-ft-bolder">
                Légende états des FUN's
            </v-card-title>
            <v-card-text class="pt-1">
                <v-row v-for="(state, index) in statesAndColors.states">
                    <v-col cols="3" class="pr-0">
                        <div class="gl-dot-legend" :style="{ 'background-color' : statesAndColors.colors[index] }"></div>
                    </v-col>
                    <v-col cols="9">
                        <div class="gl-fs-18 gl-ft-bolder gl-txt-color-2">{{ state.text }}</div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- Update notification New *KB* -->
        <v-overlay :value="showUpdateMenu" location-strategy="connected" scroll-strategy="reposition">
            <v-card style="width: 550px; min-height:400px;">
                <v-card-title class="gl-fs-20 gl-ft-bolder">
                    <v-row>
                        <v-col cols="11">
                            Mise à jour No#
                        </v-col>
                        <v-col cols="1" class="mt-0 pt-1 pr-0" style="text-align: center;">
                            <v-icon color="grey" @click="showUpdateMenu = false">close</v-icon>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="6">
                        </v-col>
                        <v-col cols="6">
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-overlay>
    </v-app>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import DevBuilder from "@/components/Dev/DevBuilder.vue";
import {ENV} from "@/constants";

export default {
    name: 'App',
    components: {DevBuilder},
    props: {
        source: String,
    },
    created() {
        //Fusion des états et des couleurs de chart
        this.statesMaintenance.shift();
        this.statesAndColors.states = this.statesMaintenance;
        this.statesAndColors.colors = this.stateColorChart;
    },
    async mounted() {
        // After everything is done, delay of 1 second
        if (!this.isLoading) {
            setTimeout(() => {
                this.showOverlay = false;
            }, 1500); //set delay here
        }
        window.addEventListener('beforeunload', this.logoutUser);
        await this.fetchUser();
        this.initLocale();//Error *KB*
        this.isUserAllreadyLoggedIn();
    },
    computed: {
        ENV() {
            return ENV
        },
        //VUEX
        ...mapState(['isLoading', 'showLoadingMessage', 'loadingMessage', 'showLoadingButton', 'isErrorState', 'errorMessage', 'loggedUser', 'availableLocales', 'devMessages','statesMaintenance','stateColorChart']),

            //mobile display
            mobileDisplay() {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return true;
                    case 'sm': return true;
                    case 'md': return true;
                    case 'lg': return false;
                    case 'xl': return false;
                }
            },

            //shows menu bar
            showMenuBar() {
                return Object.keys(this.loggedUser).length >= 1;
            },

            currentLocale() {
                return this.$i18n.locale;
            },

            currentYear() {
                return new Date().getFullYear();
            },

            onRoutePath(){
                return this.$route.path;
            }
    },
    data: () => ({
        urlName:window.location.pathname,
        drawer: null,
        drawerRight: null,
        right: false,
        isOnSectionIndexNcRepport:false,
        isOnSectionNcRepport:false,
        showLegendDialog:false,
        showOverlay: true,
        statesAndColors:{
            states:[],
            colors:[]
        },

        //New *KB*
        isNewUpdate:false,
        showUpdateMenu:false,
    }),
    methods: {
        ...mapActions(['fetchUser']),
        ...mapMutations(['setIsLoading', 'setIsErrorState', 'setErrorMessage', 'setShowLoadingMessage', 'setLoadingMessage', 'setLocale', 'deleteTokenInfo', 'setLocale', 'initLocale']),

        //closes error display
        closeError() {
            this.setErrorMessage('');
            this.setIsErrorState(false);
            this.setIsLoading(false);
        },

        //logout
        logout() {
            //deletes JWT
            this.deleteTokenInfo();

            //redirect to login page (we use window.location so it will reload the page and so the loggedUser object at the same time)
            window.location = '/';
        },
        logoutUser() {
            if(this.loggedUser.shopUser === 0){
                this.logout();
            }
        },

        toggleLocale() {
            this.setLocale(this.availableLocales.filter(l => l !== this.$i18n.locale)[0]);
        },

        isUserAllreadyLoggedIn(){
            //TODO : Logique afin de limiter l'accès aux pages et aux points morts.
            if((this.urlName === '/en/login' || this.urlName === '/fr/login') && this.loggedUser !== null){
                window.location = '/';
            }
        },

        toggleLegend(){
            this.showLegendDialog = !this.showLegendDialog;
        },

        showUpdate(){
            this.showUpdateMenu = true;
        },
    },
    watch: {
        onRoutePath(routePath) {
            this.isOnSectionNcRepport = !!routePath.includes('/nc-report/');
            this.isOnSectionIndexNcRepport = !!routePath.includes('/index-nc-reports');
            if(!this.isOnSectionIndexNcRepport && !this.isOnSectionNcRepport){
                this.showLegendDialog = false;
            }
        },
        isLoading(newVal) {
            if (!newVal) { // If isLoading is now false
                setTimeout(() => {
                    this.showOverlay = false;
                }, 1500); // Set delay here
            }
            else{
                this.showOverlay = true;
            }
        }
    }
}
</script>

<style>
* {
    font-family: 'Open Sans', sans-serif;
}
.gl-main-title{
    font-family: 'Sofia';
    font-size: 18px;
    font-weight: bolder;
}
.v-btn:not(.v-btn--round).v-size--default {
    font-size: 16px;
}
.gl-btn {
    font-weight: bolder;
}
.gl-btn:hover {
    top: -0.16em;
    transition: padding .5s, top .35s, box-shadow .4s;
    box-shadow: 2px 2px 12px #1D709B;
}
::v-deep .custom-dialog-class {
    background-color: red !important;
}

/*Loader CSS*/
.loader-container {
    position: relative;
    width: 140px;
    height: 198px;
    overflow: hidden;
    box-shadow: 1px 2px 5px black;
    z-index:999;
}
.loader {
    /*filter: blur(1px);*/
    position: absolute;
    background-color: #45eec1;
    height: 2px;
}
.loader-top {
    /*StartFirst*/
    visibility: hidden;
    width: 100%;
    top: 0;
    left: 0;
    animation: 3s linear infinite;
    animation-name: slideRight;
}
.loader-right {
    /*StartSecond*/
    visibility: hidden;
    width: 2px;
    right: 0;
    top:0;
    height: 100%;
    animation: 3s linear infinite;
    animation-delay: 1.5s;
    animation-name: slideBottom;
}
.loader-bottom {
    /*StartThird*/
    visibility: hidden;
    width: 100%;
    bottom: 0;
    left: 0;
    animation: 3s linear infinite;
    animation-delay: 3s;
    animation-name: slideLeft;
}
.loader-left {
    /*StartFour*/
    visibility: hidden;
    width: 2px;
    left: 0;
    height: 100%;
    top: 0;
    animation: 3s linear infinite;
    animation-delay: 4.5s;
    animation-name: slideTop;
}

@keyframes slideTop {
    0% {
        visibility: visible;
        transform: translateY(100%);
    }
    50% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(-100%);
    }
}
@keyframes slideRight {
    0% {
        visibility: visible;
        transform: translateX(-100%);
    }
    50% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(100%);
    }
}
@keyframes slideBottom {
    0% {
        visibility: visible;
        transform: translateY(-100%);
    }
    50% {transform: translateY(0);}
    100% {transform: translateY(100%);}
}
@keyframes slideLeft {
    0% {
        visibility: visible;
        transform: translateX(100%);
    }
    50% {transform: translateX(0);
    }
    100% {transform: translateX(-100%);
    }
}

/* print stylesheet */
@media print {
    .print-none {
        display: none;
    }
}
</style>
